// extracted by mini-css-extract-plugin
module.exports = {"root":"PDPDownloadCard_root__wRkLZ","icon":"PDPDownloadCard_icon__SsR9q","label":"PDPDownloadCard_label__N_pRC","rotation":"PDPDownloadCard_rotation__tzz1j"};